/* build/tpl */
import deps from './deps/findDeep.js';
import getFindDeep from './getFindDeep.js';
export default getFindDeep(deps);
